/**
 * App
 *
 * Top-level route table. /login is public; everything else sits behind
 * ProtectedRoute, which redirects to /login when there's no session.
 */
import { Route, Routes } from 'react-router-dom';
import { AppLayout } from './layouts/AppLayout.jsx';
import { LoginPage } from './pages/LoginPage.jsx';
import { DashboardPage } from './pages/DashboardPage.jsx';
import { WipVarianceMatrixPage } from './pages/WipVarianceMatrixPage.jsx';
import { EngagementWipSummaryPage } from './pages/EngagementWipSummaryPage.jsx';
import { EngagementProgressingPage } from './pages/EngagementProgressingPage.jsx';
import { StaffUtilizationReportPage } from './pages/StaffUtilizationReportPage.jsx';
import { UserPermissionsPage } from './pages/UserPermissionsPage.jsx';
import { StubPage } from './pages/StubPage.jsx';
import { ProtectedRoute } from './components/ProtectedRoute.jsx';

export const App = () => (
  <Routes>
    <Route path="/login" element={<LoginPage />} />

    <Route element={<ProtectedRoute />}>
      <Route element={<AppLayout />}>
        <Route index element={<DashboardPage />} />
        <Route path="/variance-matrix" element={<WipVarianceMatrixPage />} />
        <Route path="/engagement-summary" element={<EngagementWipSummaryPage />} />
        <Route path="/engagement-progressing" element={<EngagementProgressingPage />} />
        <Route path="/staff-utilization" element={<StaffUtilizationReportPage />} />
        <Route path="/user-permissions" element={<UserPermissionsPage />} />
        <Route
          path="/settings"
          element={
            <StubPage
              title="Settings"
              description="Cut-off periods, notifications, and other module settings — not yet built."
            />
          }
        />
      </Route>
    </Route>
  </Routes>
);
